var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12"},[_c('ejs-treeview',{ref:"measureTreeForDataQueryForSingleReport",attrs:{"fields":_vm.fieldsOfMeasureTreeForSingleReport,"showCheckBox":true,"nodeChecked":_vm.measureTreeNodeCheckedForSingleReport,"nodeSelected":_vm.measureTreeNodeSelectedForSingleReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }